import styled from 'styled-components';

import { flexAsRow, grid } from '@components/Styled/mixins';

const getAlertColor = (alertType, theme) => {
  switch (alertType) {
    case 'ERROR': return theme.colors.support.danger[400];
    case 'SUCCESS': return theme.colors.support.success[400];
    case 'WARNING': return theme.colors.support.warning[400];
    default: return theme.colors.support.info[400];
  }
};

const AlertWrapper = styled.div`
  ${flexAsRow(1)};

  width: 100%;
  align-items: flex-start;
  border-radius: ${({ theme }) => theme.spacing(0.5)};
  padding: ${({ theme }) => theme.spacing(2)};
  border: 1px solid ${({ alertType, theme }) => getAlertColor(alertType, theme)};
  color: ${({ alertType, theme }) => getAlertColor(alertType, theme)};
`;

const InfoWrapper = styled.div`
  ${grid()};

  grid-auto-rows: auto;
  row-gap: ${({ theme }) => theme.spacing(0.5)};
  justify-items: start;
  align-items: center;

  > h2 {
    margin: 0;
  }
`;

const AlertContent = styled.div`
  ${grid(1)};

  grid-template-columns: ${({ isIconVisible }) => (isIconVisible ? '0fr 1fr' : '1fr')};
`;

const ChildrenWrapper = styled.div`
  width: 100%;
`;

export {
  AlertWrapper,
  AlertContent,
  ChildrenWrapper,
  InfoWrapper
};
